import React from "react";
import { Helmet } from "react-helmet-async";
import { clinic } from "../constants/clinic";

interface SEOHeadProps {
  title: string;
  description: string;
  keywords?: string;
  canonical?: string;
  ogImage?: string;
  ogType?: string;
  structuredData?: object;
}

const SEOHead: React.FC<SEOHeadProps> = ({
  title,
  description,
  keywords,
  canonical = "/",
  ogImage = "/og.png",
  ogType = "website",
  structuredData,
}) => {
  const fullTitle = title.includes("わかば接骨院")
    ? title
    : `${title}｜わかば接骨院`;
  const canonicalUrl = `${clinic.domain}${canonical === "/" ? "/" : canonical}`;
  const imageUrl = ogImage.startsWith("http") ? ogImage : `${clinic.domain}${ogImage}`;

  return (
    <Helmet>
      <html lang="ja" />
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      {keywords && <meta name="keywords" content={keywords} />}
      <meta name="robots" content="index,follow,max-image-preview:large" />
      <link rel="canonical" href={canonicalUrl} />

      <meta property="og:type" content={ogType} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={imageUrl} />
      <meta property="og:image:alt" content="瀬戸市のわかば接骨院" />
      <meta property="og:site_name" content="わかば接骨院" />
      <meta property="og:locale" content="ja_JP" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={imageUrl} />

      {structuredData && (
        <script type="application/ld+json">{JSON.stringify(structuredData)}</script>
      )}
    </Helmet>
  );
};

export default SEOHead;
